import { render, staticRenderFns } from "./ModalTextClient.vue?vue&type=template&id=229337bc"
import script from "./ModalTextClient.vue?vue&type=script&lang=js"
export * from "./ModalTextClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports